export const backgroundMessages: Record<string, string> = {
  'Photo by {photographer}': '摄影：{photographer}',
  'View photo': '查看照片',
}
